import qs from "qs";
import HttpRequest from "./request";

export class WSGTDriveProvider extends HttpRequest {
  constructor() {
    super(`${process.env.VUE_APP_SERVICE_GAME}/ams/api`);
  }

  async getCampaignList(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
    });

    const { data } = await this.get(`/wsgtdrive${queryString}`);
    return data;
  }

  async createNewWSGTDrive() {
    const { data } = await this.create(`/wsgtdrive`);
    return data;
  }

  async getById(id) {
    const { data } = await this.get(`/wsgtdrive/${id}`);
    return data;
  }

  async updateCampaignInfo(id, body) {
    const { data } = await this.update(`/wsgtdrive/${id}`, body);
    return data;
  }

  async getUploadDataInfo(id) {
    const { data } = await this.get(`/wsgtdrive/${id}/data/info`);
    return data;
  }

  async getUploadDataTable(id, params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
    });

    const { data } = await this.get(
      `/wsgtdrive/${id}/data/table${queryString}`
    );

    return data;
  }

  async getUploadDataStatus(id) {
    const { data } = await this.get(`/wsgtdrive/${id}/data/upload-status`);
    return data;
  }

  async uploadDataUpload(id, form) {
    const { data } = await this.upload(`wsgtdrive/${id}/data/upload`, form);
    return data;
  }
}
